/**
 * recommendStore
 */
import Vue from 'vue';
import * as urls from '../../config/urls';
import auth from '../../utils/auth';
import * as types from '../mutation-types';


const SERACH = 'SERACH'; // 最热列表


export default {
    namespaced: true,

    state: {
        // recommend
        serachList: [],
        serachExtra: 0,
        serachQueries: {
            currPage: 1, perPageNum: 12,
        },
    },

    mutations: {

        // 分类
        [SERACH](state, { list }) {
            state.serachList = list;
        },
        [types.UPDATE_EXTRA_INFO](state, { subject, extra }) {
            state[`${subject}Extra`] = extra;
        },
        [types.UPDATE_REQUEST_QUERIES](state, { subject, queries }) {
            state[`${subject}Queries`] = queries;
        },
    },

    actions: {

        //  获最热搜索列表
        getNewVideoList({ commit }, queries) {
            const subject = 'serach';
            // const {
            //     currPage,
            //     perPageNum,
            //     ...otherQueries
            // } = queries;
            const {
                currPage = state[`${subject}Queries`].currPage,
                perPageNum = state[`${subject}Queries`].perPageNum,
                ...otherQueries
            } = queries;

            let urlUse = '';
            urlUse = urls.SEARCH_LIST_ISLOGIN;

            return new Promise((resolve, reject) => {
                Vue.http.get(urlUse, {
                    params: {
                        pageNumber: perPageNum,
                        offset: (currPage - 1) * perPageNum,
                        ...otherQueries,
                    },
                }).then((response) => {
                    const list = response.data.rows || {};
                    commit(SERACH, { list });
                    const { total } = response.data;
                    commit(types.UPDATE_EXTRA_INFO, { subject, extra: total });
                    commit(types.UPDATE_REQUEST_QUERIES, { subject, queries: { currPage, perPageNum, ...otherQueries } });
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
    },
};
